<template>
  <div id="overview-hosting-institution-tab">
    <div>
      <v-container class="content-wrapper" fluid>
        <v-row justify="center" align="center">
          <v-col cols="12" lg="10">
            <v-card
              class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
              elevation="3"
              style="border-radius: 24px;"
            >
              <!-- Back to Hosting Institutoions -->
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="auto">
                    <v-btn
                      depressed
                      rounded
                      small
                      color="blue"
                      class="white--text font-weight-bold"
                      @click="goBack"
                    >
                      <v-icon color="black" small class="mr-2">
                        mdi-arrow-left
                      </v-icon>
                      Back
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>

              <!-- Logo & Views -->
              <v-card-text>
                <v-row align="center" justify="start">
                  <v-col cols="12" md="6" sm="6" lg="6" xl="6">
                    <v-img
                      :src="hostingInstitution.logoUrl"
                      class="resource-image"
                      lazy-src="@/assets/img/blur.jpg"
                      contain
                      style="max-width: 200px; border-radius: 19.875px;"
                    ></v-img>
                    <!-- <v-card-text class="mt-5">
                      <v-icon>mdi-eye</v-icon>
                      {{ hostingInstitution.views }} registered views
                    </v-card-text>
                    <v-card-text class="pt-0">
                      <v-icon>mdi-eye</v-icon>
                      {{ hostingInstitution.nonRegisteredViews }} non registered views
                    </v-card-text> -->
                  </v-col>
                </v-row>
              </v-card-text>

              <!-- Main Body -->
              <v-card-text>
                <v-row align="center" no-gutters>
                  <v-col cols="auto">
                    <h2 class="black--text">
                      {{ hostingInstitution.name }}
                    </h2>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-if="hostingInstitution.description">
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <h3 class="primary200--text">
                      Description
                    </h3>
                    <div v-html="hostingInstitution.description"></div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-if="hostingInstitution.socialMedia.length" class="mt-0 pt-0">
                <v-row>
                  <v-col cols="12">
                    <div>
                      <social-media :list="hostingInstitution.socialMedia"></social-media>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-if="hostingInstitution.tags.length">
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <h3 class="primary200--text">
                      Tags
                    </h3>
                  </v-col>
                </v-row>
                <v-row v-if="hostingInstitution.tags.length > 0">
                  <v-chip
                    :color="color(index)"
                    v-for="(tag, index) in hostingInstitution.tags"
                    :key="index"
                    class="ma-2"
                  >
                    {{ tag }}
                  </v-chip>
                </v-row>
              </v-card-text>
              <!-- <v-card-actions>
                <v-row>
                  <v-col cols="auto">
                    <v-btn
                      @click.stop="modalLogIn = true"
                      outlined
                      class="black--text font-weight-bold mb-2"
                      rounded
                      large
                    >
                      <v-icon color="black" small class="mr-2">
                        mdi-email-outline
                      </v-icon>
                      Contact
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions> -->

              <!-- Overview Provider Tabs -->
              <v-card-text>
                <v-tabs v-model="tab" show-arrows active-class="primary200--text">
                  <v-tabs-slider color="primary200"></v-tabs-slider>
                  <v-tab v-show="providersTab">{{ $t('Providers') }}</v-tab>
                  <v-tab v-show="classificationTab">{{ $t('classification') }}</v-tab>
                  <!-- <v-tab v-show="contactTab">{{ $t('contact') }}</v-tab> -->
                  <v-tab v-show="locationTab">{{ $t('location') }}</v-tab>
                </v-tabs>

                <!-- Providers Info -->
                <v-tabs-items v-model="tab">
                  <v-tab-item
                    v-show="providersTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="0"
                  >
                    <v-row class="ma-5">
                      <v-col
                        cols="12"
                        xl="3"
                        lg="3"
                        md="3"
                        sm="6"
                        class="pa-3"
                        v-for="(provider, index) in providers"
                        :key="'provider-' + index"
                      >
                        <v-hover v-slot="{ hover }">
                          <v-card
                            class="d-flex justify-center align-center"
                            elevation="3"
                            style="border-radius: 24px; height: 100%;"
                            :class="{ 'on-hover': hover }"
                            @click="redirect(provider)"
                          >
                            <v-card-text>
                              <v-row align="center">
                                <v-col cols="12" xl="6" lg="12" md="12" sm="12" align="center">
                                  <v-img
                                    v-if="provider.logoUrl"
                                    height="120px"
                                    max-width="80%"
                                    contain
                                    v-bind:src="provider.logoUrl"
                                    :style="{
                                      borderTopLeftRadius: '24px',
                                      borderTopRightRadius: '24px',
                                    }"
                                  ></v-img>
                                  <v-img
                                    v-else
                                    height="120px"
                                    max-width="80%"
                                    contain
                                    :src="require('@/assets/img/blur.jpg')"
                                  />
                                </v-col>
                                <v-col cols="12" xl="6" lg="12" md="12" sm="12" align="center">
                                  <div class="mt-0 pt-0">
                                    <span class="text-bold black--text">
                                      {{ provider.name }}
                                    </span>
                                  </div>
                                  <div>
                                    <v-chip
                                      depressed
                                      rounded
                                      small
                                      color="blue"
                                      class="white--text font-weight-bold"
                                    >
                                      Provider
                                    </v-chip>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-hover>
                      </v-col>
                    </v-row>
                    <v-row v-if="pagesLength > 1">
                      <v-spacer></v-spacer>
                      <v-col cols="12" md="6" class="justify-end d-flex flex-row align-center">
                        <v-pagination
                          v-model="options.page"
                          :length="pagesLength"
                          :total-visible="7"
                          @input="getFilteredDataFromApi"
                        ></v-pagination>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <!-- Classification Info -->
                  <v-tab-item
                    v-show="classificationTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="1"
                  >
                    <v-row
                      v-if="hostingInstitution.classificationInfo.areasOfActivity.length"
                      class="mt-10"
                    >
                      <v-col cols="12" md="3" sm="12">
                        <label>Areas of Activity</label>
                        <p>
                          <span
                            v-for="(activity, index) in hostingInstitution.classificationInfo
                              .areasOfActivity"
                            :key="index"
                          >
                            {{ activity.name }}
                            <span
                              v-if="
                                index <
                                  hostingInstitution.classificationInfo.areasOfActivity.length - 1
                              "
                              >,</span
                            >
                          </span>
                        </p>
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="
                        hostingInstitution.classificationInfo.ecosystemStakeholderProfiles.length
                      "
                      class="mt-0 pt-0"
                    >
                      <v-col cols="12" md="3" sm="12">
                        <label
                          v-if="
                            hostingInstitution.classificationInfo.ecosystemStakeholderProfiles
                              .length > 1
                          "
                          >Ecosystem Stakeholder Profiles</label
                        >
                        <label v-else>Ecosystem Stakeholder Profile</label>
                        <p>
                          <span
                            v-for="(ecosystem, index) in hostingInstitution.classificationInfo
                              .ecosystemStakeholderProfiles"
                            :key="index"
                          >
                            {{ ecosystem.name }}
                            <span
                              v-if="
                                index <
                                  hostingInstitution.classificationInfo.ecosystemStakeholderProfiles
                                    .length -
                                    1
                              "
                              >,
                            </span>
                          </span>
                        </p>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <!-- Contact Info -->
                  <!-- <v-tab-item
                    v-show="contactTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="2"
                  >
                    <v-row v-if="hostingInstitution.contactInfo.email">
                      <v-col cols="12" lg="5" xl="4" md="6" sm="12">
                        <v-card class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6 custom-card">
                          <v-row align="center">
                            <v-col cols="12" lg="3" xl="3" md="12" sm="12">
                              <v-card-text style="filter: blur(3px);">
                                <v-avatar
                                  :size="80"
                                  class="white--text text-bold"
                                  :color="'primary'"
                                >
                                  {{ letters }}
                                </v-avatar>
                              </v-card-text>
                            </v-col>
                            <v-col cols="12" lg="9" xl="9" md="12" sm="12">
                              <v-card-title
                                class="black--text text-bold"
                                style="filter: blur(4px);"
                              >
                                {{ hostingInstitution.contactInfo.lastname }}
                                {{ hostingInstitution.contactInfo.firstname }}
                              </v-card-title>
                              <v-card-text
                                class="mt-0 pt-0 primary200--text text-bold"
                                style="filter: blur(3px);"
                              >
                                {{ hostingInstitution.contactInfo.email }}
                              </v-card-text>
                              <v-card-text
                                class="mt-0 pt-0 primary200--text text-bold"
                                style="filter: blur(3px);"
                              >
                                {{ hostingInstitution.contactInfo.phone }}
                              </v-card-text>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-tab-item> -->

                  <!-- Location Info -->
                  <v-tab-item
                    v-show="locationTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="3"
                  >
                    <v-row class="mt-10">
                      <v-col cols="12" xl="6" lg="6">
                        <div v-if="hostingInstitution.locationInfo.city" class="label-marketplace">
                          {{ $t('city') }}
                        </div>
                        <div v-if="hostingInstitution.locationInfo.city">
                          {{ hostingInstitution.locationInfo.city }}
                        </div>
                        <div
                          v-if="hostingInstitution.locationInfo.street"
                          class="label-marketplace mt-6"
                        >
                          {{ $t('street-name-number') }}
                        </div>
                        <div v-if="hostingInstitution.locationInfo.street">
                          {{ hostingInstitution.locationInfo.street }}
                        </div>
                        <div
                          v-if="hostingInstitution.locationInfo.poBox"
                          class="label-marketplace mt-6"
                        >
                          {{ $t('po-box') }}
                        </div>
                        <div v-if="hostingInstitution.locationInfo.poBox">
                          {{ hostingInstitution.locationInfo.poBox }}
                        </div>
                        <div
                          v-if="hostingInstitution.locationInfo.country.description"
                          class="label-marketplace mt-6"
                        >
                          {{ $t('country') }}
                        </div>
                        <div v-if="hostingInstitution.locationInfo.country.description">
                          {{ hostingInstitution.locationInfo.country.description }}
                        </div>
                      </v-col>
                      <v-col cols="12" xl="6" lg="6" v-if="markerLatLng != null">
                        <div>
                          <l-map
                            ref="map"
                            style="height: 400px; border-radius: 24px; z-index: 1; "
                            :zoom="2"
                            :center="[0, 0]"
                            :options="{ attributionControl: false, scrollWheelZoom: false }"
                            @ready="onMapReady"
                          >
                            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                            <l-marker :lat-lng="markerLatLng"></l-marker>
                            <l-control-attribution
                              position="bottomright"
                              prefix=""
                            ></l-control-attribution>
                          </l-map>
                        </div>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Non registered dialog -->
        <v-dialog v-model="modalLogIn" max-width="1000px">
          <v-card
            class="py-4 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8"
          >
            <v-card-title class="px-0 py-0">
              <v-row class="mx-0 px-2" align="center">
                <v-col cols="11" class="text-center d-flex justify-center align-center">
                  This action requires authentication
                </v-col>
                <v-col cols="1" class="pl-0">
                  <v-btn fab small text @click="modalLogIn = false">
                    <v-icon color="neutral500">
                      mdi-close
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider class="mt-1 mb-6 my-sm-6 my-lg-6 my-xl-6 my-md-6"></v-divider>
            <v-card-text class="pa-0 text-center">
              Only authenticated users are allowed to perform this action. Please
              <router-link
                :to="{ name: 'OverviewHostingInstitution', params: { id: $route.params.id } }"
                ><span class="font-weight-bold">Log In</span></router-link
              >
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
  </div>
</template>

<script>
import util from '@/mixins/util.js';
import EventBus from '@/helpers/event-bus.js';
import SocialMedia from '@/components/marketplace/SocialMedia';
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LControlAttribution } from 'vue2-leaflet';

export default {
  name: 'PublicOverviewHostingInstitution',
  components: {
    SocialMedia,
    LMap,
    LTileLayer,
    LMarker,
    LControlAttribution,
  },
  mixins: [util],
  data() {
    return {
      hostingInstitution: {
        logoUrl: null,
        views: null,
        nonRegisteredViews: null,
        name: '',
        description: '',
        socialMedia: [],
        tags: [],
        email: null,
        classificationInfo: {
          areasOfActivity: [],
          ecosystemStakeholderProfiles: [],
        },
        contactInfo: {
          firstname: '',
          lastname: '',
          email: '',
          phone: '',
        },
        locationInfo: {
          city: '',
          street: '',
          poBox: '',
          country: {
            id: null,
            description: '',
          },
          coordinates: null,
        },
      },
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      providers: [],
      totalItems: 0,
      pagesLength: null,
      tab: null,
      letters: '',
      map: null,
      url: process.env.VUE_APP_MAPTILE_PREFIX + '/{z}/{x}/{y}.png',
      attribution:
        '<a href="https://leafletjs.com/">Leaflet</a> | &copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      marketplacePatentsViewAll: '',
      marketplaceEquipmentViewAll: '',
      marketplaceServicesViewAll: '',
      marketplaceProvidersViewAll: '',
      isVerified: {
        verified: false,
      },
      modalLogIn: false,
      institutionSearchMarketplaceQuery: '',
    };
  },
  mounted() {
    this.getHosting();
    this.getFilteredDataFromApi();

    this.marketplacePatentsViewAll = this.$route.query.marketplacePatentsViewAll;
    this.marketplaceEquipmentViewAll = this.$route.query.marketplaceEquipmentViewAll;
    this.marketplaceServicesViewAll = this.$route.query.marketplaceServicesViewAll;
    this.marketplaceProvidersViewAll = this.$route.query.marketplaceProvidersViewAll;
    this.institutionSearchMarketplaceQuery = this.$route.query.institutionSearchMarketplace;
  },
  beforeUpdate() {
    const { firstname, lastname } = this.hostingInstitution.contactInfo;
    this.letters = '';

    if (lastname && firstname) {
      this.letters = lastname.charAt(0) + firstname.charAt(0);
    }
  },
  computed: {
    providersTab() {
      return this.providers.length > 0;
    },
    contactTab() {
      return this.hostingInstitution.contactInfo.email;
    },
    classificationTab() {
      if (
        this.hostingInstitution.classificationInfo.areasOfActivity.length ||
        this.hostingInstitution.classificationInfo.ecosystemStakeholderProfiles.length
      ) {
        return true;
      } else {
        return false;
      }
    },
    locationTab() {
      if (
        this.hostingInstitution.locationInfo.city ||
        this.hostingInstitution.locationInfo.street ||
        this.hostingInstitution.locationInfo.poBox ||
        this.hostingInstitution.locationInfo.coordinates ||
        this.hostingInstitution.locationInfo.country.id ||
        this.hostingInstitution.locationInfo.country.description ||
        this.markerLatLng
      ) {
        return true;
      } else {
        return false;
      }
    },
    markerLatLng() {
      if (
        this.hostingInstitution.locationInfo == null ||
        this.hostingInstitution.locationInfo.coordinates == null
      ) {
        return null;
      } else {
        const coordinates = this.hostingInstitution.locationInfo.coordinates.split(',');
        try {
          return L.latLng(coordinates[0].trim(), coordinates[1].trim());
        } catch (e) {
          console.log(e);
          return null;
        }
      }
    },
  },
  methods: {
    getHosting() {
      EventBus.$emit('waiting', true);
      const id = this.$route.params.id;

      this.axios
        .get(`/api/v1/hosting-institutions/${id}`)
        .then(response => {
          console.log('Get Hosting Institution', response.data);

          this.hostingInstitution.logoUrl = response.data.logoUrl;
          this.hostingInstitution.views = response.data.views;
          this.hostingInstitution.nonRegisteredViews = response.data.viewsNonRegistered;
          this.hostingInstitution.name = response.data.name;
          this.hostingInstitution.socialMedia = response.data.socialMedia;
          this.hostingInstitution.tags = response.data.tags;

          this.hostingInstitution.classificationInfo = {
            areasOfActivity: response.data.areasOfActivities,
            ecosystemStakeholderProfiles: response.data.ecosystemStakeholderProfiles,
          };

          this.hostingInstitution.locationInfo = {
            city: response.data.city,
            street: response.data.street,
            poBox: response.data.poBox,
            coordinates: response.data.coordinates,
            country: {
              id: response.data.country?.id,
              description: response.data.country?.description,
            },
          };

          const verifiedContact = response.data.publicContacts?.find(
            contact => contact.verified === true,
          );

          this.isVerified.verified = verifiedContact ? verifiedContact.verified : false;

          this.hostingInstitution.contactInfo = {
            firstname: verifiedContact?.firstname,
            lastname: verifiedContact?.lastname,
            email: verifiedContact?.email,
            phone: verifiedContact?.phone,
            verified: verifiedContact ? verifiedContact.verified : false,
          };

          // this.hostingInstitution.contactInfo = {
          //   firstname:
          //     response.data.publicContactsVerified &&
          //     response.data.publicContactsVerified.length > 0
          //       ? response.data.publicContactsVerified[0].firstname
          //       : '-',
          //   lastname:
          //     response.data.publicContactsVerified &&
          //     response.data.publicContactsVerified.length > 0
          //       ? response.data.publicContactsVerified[0].lastname
          //       : '-',
          //   email:
          //     response.data.publicContactsVerified &&
          //     response.data.publicContactsVerified.length > 0
          //       ? response.data.publicContactsVerified[0].email
          //       : '-',
          //   phone:
          //     response.data.publicContactsVerified &&
          //     response.data.publicContactsVerified.length > 0
          //       ? response.data.publicContactsVerified[0].phone
          //       : '-',
          // };
          this.hostingInstitution.description = response.data.description;
        })

        .catch(error => {
          console.error('Error fetching hosting institution data:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    getFilteredDataFromApi() {
      const paginationParams = this.getParams();

      const institutions = this.$route.params.id;

      const filteredParams = {
        ...paginationParams,
        institutions,
      };

      console.log('Combined params for request:', filteredParams);

      this.loading = true;
      EventBus.$emit('waiting', true);

      this.axios
        .get('/api/v1/providers', { params: filteredParams })
        .then(response => {
          console.log('Get Filtered Data:', response.data);
          this.providers = response.data.content;
          this.totalItems = response.data.total;
          this.pagesLength = response.data.pagesLength;
        })
        .catch(error => {
          console.error('Error fetching providers:', error);
        })
        .finally(() => {
          this.loading = false;
          EventBus.$emit('waiting', false);
        });
    },
    onItemsPerPageChange() {
      this.options.page = 1;
      this.getFilteredDataFromApi();
    },
    getParams() {
      const { page, itemsPerPage } = this.options;
      const query = {
        index: itemsPerPage === -1 ? 0 : page - 1,
        size: itemsPerPage === -1 ? 1000 : itemsPerPage,
      };
      return query;
    },
    redirect(provider) {
      const id = provider.id;

      if (id && this.$store.getters.roles != null) {
        this.$router.push({ name: 'OverviewProvider', params: { id: id } });
      } else {
        this.$router.push({ name: 'PublicOverviewProvider', params: { id: id } });
      }
    },
    goBack() {
      if (
        this.$route.query.marketplaceInstitutionViewAll &&
        !this.$store.getters.roles &&
        this.$route.query.filters
      ) {
        const marketplaceInstitutionViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Hosting Institutions';
        let routePath = '';
        routePath = '/public-catalogue-marketplace/hosting-institutions';
        const filters = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceInstitutionViewAll, ...filters },
        });
      } else if (
        this.marketplaceEquipmentViewAll &&
        !this.$store.getters.roles &&
        this.$route.query.fromTable
      ) {
        const marketplaceEquipmentViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Equipment';
        let routePath = '';
        routePath = '/public-catalogue-marketplace/equipment';
        const fromTable = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceEquipmentViewAll, ...fromTable },
        });
      } else if (
        this.marketplaceServicesViewAll &&
        !this.$store.getters.roles &&
        this.$route.query.fromTable
      ) {
        const marketplaceServicesViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Services';
        let routePath = '';
        routePath = '/public-catalogue-marketplace/services';
        const fromTable = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceServicesViewAll, ...fromTable },
        });
      } else if (
        this.marketplaceProvidersViewAll &&
        !this.$store.getters.roles &&
        this.$route.query.filters
      ) {
        const marketplaceProvidersViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Providers';
        let routePath = '';
        routePath = '/public-catalogue-marketplace/providers';
        const filters = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceProvidersViewAll, ...filters },
        });
      } else if (
        this.marketplaceProvidersViewAll &&
        !this.$store.getters.roles &&
        this.$route.query.searchBar
      ) {
        localStorage.setItem('tabIndex', 3);
        const searchBar = this.$route.query;
        this.$router.push({
          name: 'PublicSearchMarketplace',
          query: searchBar,
        });
      } else if (
        this.marketplaceEquipmentViewAll &&
        !this.$store.getters.roles &&
        this.$route.query.filters
      ) {
        const marketplaceEquipmentViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Equipment';
        let routePath = '';
        routePath = '/public-catalogue-marketplace/equipment';
        const filters = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceEquipmentViewAll, ...filters },
        });
      } else if (
        this.marketplaceEquipmentViewAll &&
        !this.$store.getters.roles &&
        this.$route.query.searchBar
      ) {
        localStorage.setItem('tabIndex', 1);
        const searchBar = this.$route.query;
        this.$router.push({
          name: 'PublicSearchMarketplace',
          query: searchBar,
        });
      } else if (
        this.marketplaceServicesViewAll &&
        !this.$store.getters.roles &&
        this.$route.query.filters
      ) {
        const marketplaceServicesViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Services';
        let routePath = '';
        routePath = '/public-catalogue-marketplace/services';
        const filters = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceServicesViewAll, ...filters },
        });
      } else if (
        this.marketplaceServicesViewAll &&
        !this.$store.getters.roles &&
        this.$route.query.searchBar
      ) {
        localStorage.setItem('tabIndex', 0);
        const searchBar = this.$route.query;
        this.$router.push({
          name: 'PublicSearchMarketplace',
          query: searchBar,
        });
      } else if (
        this.marketplaceProvidersViewAll &&
        !this.$store.getters.roles &&
        this.$route.query.fromTable
      ) {
        const marketplaceProvidersViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Providers';
        let routePath = '';
        routePath = '/public-catalogue-marketplace/providers';
        const fromTable = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceProvidersViewAll, ...fromTable },
        });
      } else if (
        this.institutionSearchMarketplaceQuery &&
        !this.$store.getters.roles &&
        this.$route.query.filters
      ) {
        localStorage.setItem('tabIndex', 4);
        this.$router.go(-1);
      } else if (
        this.marketplacePatentsViewAll &&
        !this.$store.getters.roles &&
        this.$route.query.fromTable
      ) {
        const marketplacePatentsViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Patents';
        let routePath = '';
        routePath = '/public-catalogue-marketplace/patents';
        const fromTable = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplacePatentsViewAll, ...fromTable },
        });
      } else if (
        this.marketplacePatentsViewAll &&
        !this.$store.getters.roles &&
        this.$route.query.filters
      ) {
        const marketplacePatentsViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Patents';
        let routePath = '';
        routePath = '/public-catalogue-marketplace/patents';
        const filters = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplacePatentsViewAll, ...filters },
        });
      } else if (
        this.marketplacePatentsViewAll &&
        !this.$store.getters.roles &&
        this.$route.query.searchBar
      ) {
        localStorage.setItem('tabIndex', 2);
        const searchBar = this.$route.query;
        this.$router.push({
          name: 'PublicSearchMarketplace',
          query: searchBar,
        });
      } else {
        this.$router.go(-1);
      }
    },
    onMapReady(map) {
      this.map = map;
      if (this.markerLatLng) {
        this.map.flyTo(this.markerLatLng, 15, {
          duration: 2,
          easeLinearity: 0.25,
        });
      }
    },
  },
  watch: {
    providers(val) {
      if (val.length > 0) {
        this.tab = 0;
      } else {
        this.$nextTick(() => {
          if (this.classificationTab) this.tab = 1;
          else if (this.contactTab) this.tab = 2;
          else if (this.locationTab) this.tab = 3;
        });
      }
    },
    classificationTab(val) {
      if (val && !this.providersTab) {
        this.tab = 1;
      }
    },
  },
};
</script>

<style>
#overview-hosting-institution-tab .v-toolbar {
  background: rgba(250, 250, 250, 1) !important;
  border-bottom: 2px solid #f4f2f9 !important;
}

#overview-hosting-institution-tab .custom-app-bar {
  background-color: rgba(0, 0, 0, 0) !important;
  border-bottom: none !important;
}
</style>
